<template>
    <mini-calculator-page>
        <div slot="summary-panel" class="flex-grid--vertical">
            <div class="p-animated-calc__results a-form-inputs u-full-width u-margin-auto">
                <mini-calculator-header title="Retirement Age Calculator" icon="retirement-calculator"/>

                <control for="gender" label="Gender">
                    <select v-field-control
                            required
                            name="gender"
                            v-model="gender" ref="gender"
                            @change="handler">
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                    </select>
                    <control-error :show="$error('gender')">
                        The gender is required
                    </control-error>
                </control>

                <control for="date_of_birth" label="Date of Birth">
                    <date-input v-model="dateOfBirth" ref="dateOfBirth"
                                v-field-control:date_of_birth.required="{type:'date'}"
                                @input="handler">

                    </date-input>
                    <control-error :show="$error('date_of_birth')">
                        The date of birth is required and must be in the format DD/MM/YYYY
                    </control-error>
                </control>

                <h2 class="u-r-margin-top-40">
                    Result
                </h2>

                <control for="retirement_age" label="Retirement Age">
                    <input autocomplete="off" disabled="disabled"
                           id="retirement_age" type="number"
                           name="retirement_age"
                           v-two-dp
                           v-model="retirementAge">
                </control>

                <control for="retirement_date" label="Retirement Date">
                    <input autocomplete="off" disabled="disabled"
                           id="retirement_date" type="text"
                           name="retirement_date"
                           v-model="retirementDate">
                </control>
            </div>
        </div>

        <div slot="results-panel" class="flex-grid--vertical" v-show="showResults">
            <div class="p-animated-calc__results-panel u-full-width u-margin-auto">
                <h2>
                    Explanation
                </h2>

                <p>
                    This calculator works out when people will reach their State Pension age, under current legislation,
                    based on their gender and date of birth. The Pensions Act 2014 provides for a regular review of the
                    State Pension age, at least once every five years.
                </p>
                <p>
                    For a {{ gender }} born on {{ dateOfBirth }}, the retirement age is <strong>{{ retirementAge }}</strong> which is reached on <strong>{{ retirementDate }}</strong>
                </p>
            </div>
        </div>
    </mini-calculator-page>
</template>

<script type="text/babel">
    import {mapGetters, mapActions} from 'vuex';
    import Control from 'components/form/Control.vue';
    import ControlError from 'components/form/control/Error.vue';
    import FormValidator from 'components/form/validator/mixin';
    import MiniCalculatorPage from 'pages/mini-calculators/components/MiniCalculatorPage';
    import miniCalcIcons from 'components/Icons.vue';
    import DateInput from 'components/form/control/DateInput.vue';
    import CalculatorKeyBindings from 'pages/mini-calculators/calculators/mixins/MiniCalculatorBindings';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';
    import Intro from 'pages/mini-calculators/calculators/CalculatorComponents/Intro';
    import moment from 'moment';
    import currencyFormat from 'mixins/currencyFormat';
    import MiniCalculatorHeader from 'pages/mini-calculators/components/MiniCalculatorHeader';

    export default {
        name: 'retirement-age',
        created() {
            this.resetForm();
        },
        data: function() {
            return {
                showResults: false
            }
        },
        computed: {
            ...mapGetters('mini/retirementAge', {
                getValue: 'value'
            }),
            gender: {
                get() {
                    return this.getValue('gender');
                },
                set(value) {
                    this.updateValue({key: 'gender', value});
                }
            },
            dateOfBirth: {
                get() {
                    return this.getValue('dateOfBirth');
                },
                set(value) {
                    this.updateValue({key: 'dateOfBirth', value});
                }
            },
            retirementAge: {
                get() {
                    return this.getValue('retirementAge');
                },
            },
            retirementDate: {
                get() {
                    return this.getValue('retirementDate');
                },
            },
        },
        mixins: [
            FormValidator,
            CalculatorKeyBindings,
            currencyFormat
        ],
        directives: {
            'two-dp': TwoDecimalPlaces
        },
        components: {
            Control,
            ControlError,
            DateInput,
            MiniCalculatorPage,
            MiniCalculatorHeader,
            miniCalcIcons,
            Intro,
        },
        methods: {
            ...mapActions('mini/retirementAge', {
                updateValue: 'update',
                calcRetirementAge: 'calcRetirementAge',
                resetForm: 'reset'
            }),
            isValid() {
                return (
                    this.gender !== null
                    && this.dateOfBirth !== null
                    && moment(this.dateOfBirth, 'DD/MM/YYYY').isValid()
                );
            },
            recalculate() {
                if (!this.isValid()) {
                    return;
                }

                this.calcRetirementAge();
            },
            handler: function () {
                this.recalculate();

                if (!this.isValid()) {
                    return;
                }

                this.hidePrompt();
                this.showResults = true;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// retirementAge.vue?1228af0d